import customerManagementSurveyReducer from "./customerManagementSurveyReducer";

const customerManagementSurveyReducers = {
    customerManagementSurvey: customerManagementSurveyReducer,
}

export default customerManagementSurveyReducers;